var _rect, _rect2, _rect3, _defs, _g, _g2, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-0dd9719b": "",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "66 105 210.00000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    style: {
      margin: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-v-0dd9719b": "",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff",
    fillOpacity: 1,
    className: "background"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-v-0dd9719b": "",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#watermark)",
    fillOpacity: 1,
    className: "watermarklayer"
  })), /*#__PURE__*/React.createElement("g", {
    "data-v-0dd9719b": "",
    className: "iconmbgsvg",
    transform: "translate(67.29141235373093,105.0898666381836)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    "hollow-target": "textNormalTran"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 40.499999999999986,
    height: 39.82026802481638,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 40.499999999999986,
    height: 39.82026802481638,
    filtersec: "colorsb4865477608",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-0.0032841155771166086 -0.00264777266420424 43.796260833740234 43.06103515625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 24.5,
    y1: 6.6,
    x2: -1.17,
    y2: 13.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61c1ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 9.27,
    y1: 18.05,
    x2: 5.56,
    y2: 40.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#713593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8479a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13.51,
    y1: 37.44,
    x2: 38.25,
    y2: 37.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f16522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 32.25,
    y1: 31.37,
    x2: 45.03,
    y2: 17.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf0f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 31.67,
    y1: 14.88,
    x2: 24.84,
    y2: -4.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92c700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0d72f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.27,8.34,16.22,2.09c-.79-.8-1.64-.48-1.91.73l0,2A16.46,16.46,0,0,0,8.46,6.58a16.21,16.21,0,0,0-7.27,7.76A15,15,0,0,0,0,19.41a.79.79,0,0,0,1.54.31c.22-.59.29-.91.65-1.74a11.69,11.69,0,0,1,10.64-7.19c-.18.39-.38.83-.6,1.33-.28,1.21.38,1.86,1.42,1.47l8.13-3.06A1.24,1.24,0,0,0,22.27,8.34Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.22,40.91c-.48-.39-.77-.55-1.44-1.16A11.7,11.7,0,0,1,8.22,27.41l1.08,1c1.07.64,1.89.21,1.84-.9l-.39-8.68a1.25,1.25,0,0,0-1.94-1.15L1,21.51c-1,.5-1,1.4.1,2L3,24.2a16.46,16.46,0,0,0-.15,6.07A16.17,16.17,0,0,0,8,39.58a15.12,15.12,0,0,0,4.45,2.7A.79.79,0,0,0,13.22,40.91Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,36.35c-.52.34-.77.56-1.55,1a11.7,11.7,0,0,1-12.83-.43l1.27-.73c.94-.82.78-1.73-.29-2l-8.38-2.31a1.24,1.24,0,0,0-1.68,1.49L14.76,42c.17,1.11,1,1.35,2,.54L18,40.89a16.6,16.6,0,0,0,5.72,2,16.27,16.27,0,0,0,10.45-2,15,15,0,0,0,3.93-3.41A.79.79,0,0,0,37,36.35Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.12,27a16.25,16.25,0,0,0,1.32-10.55,14.89,14.89,0,0,0-2-4.8.79.79,0,0,0-1.42.65c.16.61.3.91.49,1.79a11.7,11.7,0,0,1-4.38,12.07c-.08-.42-.18-.89-.3-1.43-.48-1.14-1.4-1.27-2-.35L29,31.66a1.25,1.25,0,0,0,.89,2.07l8.57,1.49c1.11.18,1.61-.57,1.12-1.71l-1.17-1.66A16.67,16.67,0,0,0,42.12,27Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1,9l-1.94.6a16.53,16.53,0,0,0-3.44-5A16.21,16.21,0,0,0,23.09.06,14.83,14.83,0,0,0,17.9.5a.79.79,0,0,0,.18,1.55c.63,0,1,0,1.86.09A11.72,11.72,0,0,1,30.07,10l-1.46-.16c-1.23.11-1.64.94-.95,1.81l5.42,6.79a1.25,1.25,0,0,0,2.24-.21l4.07-7.69C39.9,9.57,39.34,8.86,38.1,9Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.24992183099675,32.77113389968872)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-gra": "path-name",
    fillRule: "",
    className: "tp-name",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.44000000000000006)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    transform: "translate(0, 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-gra": "path-slogan",
    fillRule: "",
    className: "tp-slogan",
    fill: "#000000",
    transform: "translate(-78.16899871826172,-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.33799743652344,
    width: 27
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.4000000000000004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95-8.53L7.56-2.11L8.87-8.53L10.34-8.53L8.37 0L6.96 0L5.33-6.23L3.67 0L2.25 0L0.28-8.53L1.75-8.53L3.08-2.12L4.71-8.53L5.95-8.53ZM18.23-4.52L18.23-4.04Q18.23-2.79 17.80-1.84Q17.37-0.90 16.56-0.39Q15.76 0.12 14.71 0.12L14.71 0.12Q13.67 0.12 12.86-0.39Q12.05-0.90 11.60-1.83Q11.16-2.77 11.16-4.00L11.16-4.00L11.16-4.48Q11.16-5.72 11.60-6.68Q12.04-7.63 12.85-8.14Q13.65-8.65 14.70-8.65Q15.74-8.65 16.54-8.15Q17.35-7.65 17.79-6.71Q18.23-5.77 18.23-4.52L18.23-4.52ZM16.75-4.04L16.75-4.49Q16.75-5.91 16.22-6.66Q15.68-7.42 14.70-7.42L14.70-7.42Q13.73-7.42 13.19-6.67Q12.65-5.91 12.64-4.54L12.64-4.54L12.64-4.04Q12.64-2.64 13.19-1.87Q13.73-1.10 14.71-1.10L14.71-1.10Q15.69-1.10 16.22-1.85Q16.75-2.60 16.75-4.04L16.75-4.04ZM24.56 0L22.85-3.29L21.19-3.29L21.19 0L19.71 0L19.71-8.53L22.71-8.53Q24.19-8.53 24.99-7.87Q25.79-7.21 25.79-5.95L25.79-5.95Q25.79-5.10 25.38-4.52Q24.97-3.94 24.23-3.63L24.23-3.63L26.14-0.08L26.14 0L24.56 0ZM21.19-7.34L21.19-4.48L22.72-4.48Q23.47-4.48 23.89-4.85Q24.31-5.23 24.31-5.89L24.31-5.89Q24.31-6.57 23.92-6.95Q23.53-7.32 22.76-7.34L22.76-7.34L21.19-7.34ZM32.21 0L29.65-3.69L28.68-2.66L28.68 0L27.20 0L27.20-8.53L28.68-8.53L28.68-4.53L29.50-5.54L32.00-8.53L33.79-8.53L30.62-4.75L33.97 0L32.21 0ZM42.21-2.20L42.21-2.20Q42.21-2.76 41.82-3.06Q41.42-3.37 40.39-3.68Q39.36-3.99 38.75-4.37L38.75-4.37Q37.58-5.10 37.58-6.28L37.58-6.28Q37.58-7.31 38.42-7.98Q39.26-8.65 40.61-8.65L40.61-8.65Q41.50-8.65 42.19-8.32Q42.89-7.99 43.29-7.39Q43.69-6.78 43.69-6.04L43.69-6.04L42.21-6.04Q42.21-6.71 41.79-7.09Q41.37-7.46 40.59-7.46L40.59-7.46Q39.87-7.46 39.47-7.15Q39.06-6.84 39.06-6.29L39.06-6.29Q39.06-5.82 39.50-5.50Q39.93-5.19 40.93-4.90Q41.92-4.60 42.53-4.22Q43.13-3.84 43.41-3.35Q43.69-2.87 43.69-2.21L43.69-2.21Q43.69-1.14 42.88-0.51Q42.06 0.12 40.66 0.12L40.66 0.12Q39.73 0.12 38.96-0.23Q38.18-0.57 37.75-1.17Q37.32-1.78 37.32-2.58L37.32-2.58L38.80-2.58Q38.80-1.85 39.28-1.45Q39.76-1.05 40.66-1.05L40.66-1.05Q41.43-1.05 41.82-1.37Q42.21-1.68 42.21-2.20ZM50.01 0L47.44-3.69L46.48-2.66L46.48 0L44.99 0L44.99-8.53L46.48-8.53L46.48-4.53L47.30-5.54L49.79-8.53L51.59-8.53L48.42-4.75L51.77 0L50.01 0ZM54.12-8.53L54.12 0L52.65 0L52.65-8.53L54.12-8.53ZM57.43-8.53L57.43-1.18L61.30-1.18L61.30 0L55.95 0L55.95-8.53L57.43-8.53ZM63.92-8.53L63.92-1.18L67.79-1.18L67.79 0L62.44 0L62.44-8.53L63.92-8.53ZM75.03 0L71.92 0L71.92-8.53L74.84-8.53Q76.29-8.53 77.04-7.95Q77.80-7.37 77.80-6.22L77.80-6.22Q77.80-5.64 77.48-5.17Q77.17-4.70 76.56-4.44L76.56-4.44Q77.25-4.25 77.63-3.74Q78.01-3.22 78.01-2.49L78.01-2.49Q78.01-1.29 77.24-0.64Q76.46 0 75.03 0L75.03 0ZM75.17-3.85L73.40-3.85L73.40-1.18L75.05-1.18Q75.74-1.18 76.14-1.53Q76.53-1.88 76.53-2.49L76.53-2.49Q76.53-3.82 75.17-3.85L75.17-3.85ZM73.40-7.34L73.40-4.94L74.85-4.94Q75.54-4.94 75.93-5.25Q76.32-5.57 76.32-6.14L76.32-6.14Q76.32-6.77 75.96-7.05Q75.60-7.34 74.84-7.34L74.84-7.34L73.40-7.34ZM84.33 0L82.62-3.29L80.97-3.29L80.97 0L79.49 0L79.49-8.53L82.49-8.53Q83.96-8.53 84.77-7.87Q85.57-7.21 85.57-5.95L85.57-5.95Q85.57-5.10 85.16-4.52Q84.74-3.94 84.01-3.63L84.01-3.63L85.92-0.08L85.92 0L84.33 0ZM80.97-7.34L80.97-4.48L82.49-4.48Q83.24-4.48 83.67-4.85Q84.09-5.23 84.09-5.89L84.09-5.89Q84.09-6.57 83.70-6.95Q83.31-7.32 82.54-7.34L82.54-7.34L80.97-7.34ZM88.54-8.53L88.54 0L87.06 0L87.06-8.53L88.54-8.53ZM92.82 0L90.36 0L90.36-8.53L92.88-8.53Q94.01-8.53 94.89-8.03Q95.77-7.52 96.25-6.60Q96.73-5.67 96.73-4.48L96.73-4.48L96.73-4.05Q96.73-2.84 96.24-1.92Q95.76-1.00 94.87-0.50Q93.97 0 92.82 0L92.82 0ZM92.88-7.34L91.85-7.34L91.85-1.18L92.81-1.18Q93.98-1.18 94.60-1.91Q95.23-2.64 95.24-4.01L95.24-4.01L95.24-4.48Q95.24-5.87 94.63-6.60Q94.03-7.34 92.88-7.34L92.88-7.34ZM104.74-4.38L104.74-1.11Q104.28-0.50 103.46-0.19Q102.64 0.12 101.60 0.12L101.60 0.12Q100.52 0.12 99.70-0.37Q98.87-0.86 98.42-1.76Q97.97-2.67 97.96-3.87L97.96-3.87L97.96-4.54Q97.96-6.47 98.88-7.56Q99.81-8.65 101.47-8.65L101.47-8.65Q102.89-8.65 103.73-7.95Q104.57-7.24 104.74-5.92L104.74-5.92L103.28-5.92Q103.04-7.46 101.50-7.46L101.50-7.46Q100.50-7.46 99.98-6.74Q99.46-6.02 99.45-4.63L99.45-4.63L99.45-3.98Q99.45-2.60 100.03-1.83Q100.61-1.07 101.65-1.07L101.65-1.07Q102.79-1.07 103.27-1.58L103.27-1.58L103.27-3.25L101.51-3.25L101.51-4.38L104.74-4.38ZM111.36-4.98L111.36-3.81L107.85-3.81L107.85-1.18L111.95-1.18L111.95 0L106.37 0L106.37-8.53L111.91-8.53L111.91-7.34L107.85-7.34L107.85-4.98L111.36-4.98Z",
    transform: "translate(-0.28125, 8.6484375)"
  })))))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logoBlack.16c2c3860a314bab59f82f9b4fecff0f.svg";
export { ForwardRef as ReactComponent };